import React from 'react';
import { AppState } from '../store/state';
import { AppDispatch } from '../store/store';
import { connect } from 'react-redux';
import PersonalInfoForm from '../components/PersonalInfoForm/PersonalInfoForm';
import { changeNameRequest, UpdateUserDTO, User } from '../store/user/types';
import { selectCurrentUser, selectIsPersonalInfoCompleted } from '../store/selectors';
import { Button } from '../components/ui';
import userSlice from '../store/user/slice';
import { useTranslation } from 'react-i18next';
import UserStepper from '../components/UserStepper/UserStepper';

interface Props {
  user: User;
  isPersonalInfoCompleted: boolean;
  updateUserAction: (data: UpdateUserDTO) => void;
  changeNameRequestAction: (data: changeNameRequest) => void;
}

const PersonalInfoWizardPage: React.FC<Props> = ({
  user,
  isPersonalInfoCompleted,
  updateUserAction,
  changeNameRequestAction,
}) => {
  const { t } = useTranslation();

  const getSteps = (step: number, totalSteps: number) => {
    return [
      {
        content: (
          <PersonalInfoForm
            formData={{
              first_name: user.person.first_name,
              middle_name: user.person.middle_name ?? '',
              last_name: user.person.last_name,
              country: user.person.country ?? '',
              organization: user.person.organization ?? '',
              organization2: user.person.organization2 ?? '',
              organization3: user.person.organization3 ?? '',
              organization4: user.person.organization4 ?? '',
              organization5: user.person.organization5 ?? '',
            }}
            onSave={(data) => {
              updateUserAction({
                ...user.person,
                ...data,
              });
            }}
            onChangeName={user.person.name_validated_at ? changeNameRequestAction : undefined}
          >
            <Button type="submit" className="w-48 place-self-center">
              <span className="px-14">
                {totalSteps == 1
                  ? t('Complete')
                  : t(`Complete {{step}} of {{total}}`, { step: step + 1, total: totalSteps })}
              </span>
            </Button>
          </PersonalInfoForm>
        ),
        isCompleted: isPersonalInfoCompleted,
      },
    ];
  };

  return <UserStepper getSteps={getSteps} />;
};

const mapStateToProps = (state: AppState) => ({
  user: selectCurrentUser(state),
  isPersonalInfoCompleted: selectIsPersonalInfoCompleted(state),
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  updateUserAction: (data: UpdateUserDTO) => dispatch(userSlice.actions.UPDATE(data)),
  changeNameRequestAction: (data: changeNameRequest) => dispatch(userSlice.actions['CHANGE-NAME-REQUEST'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfoWizardPage);
